import axios from '@/utils/fetch'
const context = '/mall';
const version = 'v1.0';
const _module = `${context}/${version}/mobile`

export default {
    login(data) {
        return axios({
            url: `${_module}/login`,
            method: 'POST',
            data
        })
    },
    // , // 服务条款
    terms_of_service(data) {
        return axios({
            url: `${_module}/terms_of_service`,
            method: 'GET',
            loading: false,
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/login.js